import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';

import {getAllReconciliations, getAllReconciliationsNoEngagementSelected} from '../../../../actions/Reconciliations';
import selectReconciliationsData from '../../../../reducers/Reconciliations/selectors/selectReconciliationsData';
import selectAllEntitiesWithCompId from '../../../../reducers/Metrics/selector/selectAllEntitiesWithCompId';
import selectProjectId from '../../../../reducers/Project/selectors/selectProjectId';

import ReconciliationsTable from '../../../Common/ReconciliationsTable';
import StyledReconciliations from './StyledReconciliations';

const Reconciliations = () => {
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();
	const [items] = selectReconciliationsData();
	const entities = selectAllEntitiesWithCompId();
	const projectId = selectProjectId();

	useEffect(() => {
		if (projectId) handleGetReconciliations();
	}, [projectId, entities?.length]);

	const handleGetReconciliations = () => {
		setIsLoading(true);
		const primaryEngagementId = entities.find((item) => item.entityLevel === 2)?.engagements[0];
		if (primaryEngagementId === undefined) {
			dispatch(getAllReconciliationsNoEngagementSelected({projectId, primaryEngagementId, entities})).then(() => setIsLoading(false));
			return;
		}
		dispatch(getAllReconciliations({projectId, primaryEngagementId, entities})).then(() => setIsLoading(false));
	};

	const props = {
		items: items?.map((item) => ({...item, id: item.componentId}))
	};

	return (
		<StyledReconciliations isLoading={isLoading} blockContent>
			<ReconciliationsTable {...props} />
		</StyledReconciliations>
	);
};

Reconciliations.propTypes = {};

export default Reconciliations;
